// Province handling for Temp Staff registration.
// The Profile address province (region code) is mandatory. The TDON tax form is Ontario-only, and
// the Smart Serve certificate is shown under each province's own alcohol server program name.

export const CANADIAN_PROVINCES = ["AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT"];

export const ONTARIO = "ON";

// Registration items that only apply to Ontario residents. Empty now: "tdon-tax" shows the
// provincial TD1 for every province (the backend picks the form from the Profile province).
export const ONTARIO_ONLY_ITEM_IDS = [];

export const normalizeProvince = (value) => String(value || "").trim().toUpperCase();

export const isCanadianProvince = (value) => CANADIAN_PROVINCES.includes(normalizeProvince(value));

export const isSmartServe = (name) => /smart\s*serve/i.test(String(name || ""));

// Smart Serve is Ontario's alcohol server certificate; other provinces have their own program,
// shown under that name. Provinces not listed (the territories) have no equivalent.
export const ALCOHOL_SERVER_CERT_NAMES = {
  ON: "Smart Serve",
  AB: "ProServe",
  BC: "Serving It Right (SIR)",
  SK: "Serve It Right Saskatchewan (SIRS)",
  MB: "Smart Choices",
  QC: "Service in Action / Action Service",
  NB: "It's Good Business – Responsible Service of Alcohol",
  NS: "It's Good Business",
  PE: "It's Our Business",
  NL: "It's Good Business – Responsible Service of Alcohol",
};

// Smart Serve is hidden only when the province is known and has no alcohol server program
export const hidesAlcoholServerCert = (province) =>
  !!province && !ALCOHOL_SERVER_CERT_NAMES[normalizeProvince(province)];

// Certificate name to show for the profile province (Smart Serve becomes e.g. "ProServe" in Alberta)
export const certDisplayName = (name, province) =>
  (isSmartServe(name) && ALCOHOL_SERVER_CERT_NAMES[normalizeProvince(province)]) || name;

// Province from the saved backend value (set by the Register page) or the local Profile draft
export const getRegistrationProvince = (accountId) => {
  if (!accountId) return "";
  try {
    const synced = localStorage.getItem(`province_${accountId}`);
    if (synced) return normalizeProvince(synced);
    const draft = JSON.parse(localStorage.getItem(`form_${accountId}_profile`) || "{}");
    return normalizeProvince(draft?.address?.region || draft?.address?.province);
  } catch {
    return "";
  }
};

export const saveRegistrationProvince = (accountId, province) => {
  if (!accountId) return;
  try {
    if (province) localStorage.setItem(`province_${accountId}`, normalizeProvince(province));
    else localStorage.removeItem(`province_${accountId}`);
  } catch {
    // ignore storage failures
  }
};

// Ontario-only documents are hidden only when the province is known and is not Ontario
export const excludesOntarioOnly = (province) => !!province && normalizeProvince(province) !== ONTARIO;
